// 🚨 AUTO-GENERADO desde InterestEntryDataType.ts - No editar manualmente

export const InterestEntryFormDataKeys = [
  "id",
  "numero",
  "days",
  "amount",
  "anulado",
  "created",
  "currencyId",
  "currency",
  "invoiceId",
  "invoice",
  "settlementId",
  "settlement",
  "settlementInterestId",
  "settlementInterest",
  "recibeId",
  "recibe"
] as const;
